export * from "./carousel";
export * from "./carousel-skeleton";

import { CarouselComponent } from "./carousel";
import { CarouselSkeletonComponent } from "./carousel-skeleton";

export const CarouselOrganisms = [CarouselComponent, CarouselSkeletonComponent];
